export class InfoSpedizioniVini {
    spedizioneGratis: number;
    isSpedizioneGratis: boolean;
    pezziMin: number;
    idCantina: number;
    codiceForm: string;
    scontoFrom: number;
    scontoPercentuale: number;
    scontoEuro: number;
    attivoScontoPerc: boolean;
    inizioPromo: any;
    finePromo: any;
    attivoVoucherCarrello: boolean;
    scontoFromVoucher: number;
    attivoScontoFromVoucher: boolean;

    constructor(info) {
        this.spedizioneGratis = parseFloat(info.spedizioneGratis);
        this.isSpedizioneGratis = info.isSpedizioneGratis === '1' ? true : false;
        this.pezziMin = parseInt(info.pezziMin, 10);
        this.idCantina = parseInt(info.idCantina, 10);
        this.codiceForm = info.codiceForm;
        this.scontoFrom = parseFloat(info.scontoFrom);
        this.scontoPercentuale = parseInt(info.scontoPercentuale, 10);
        this.scontoEuro = parseFloat(info.scontoEuro);
        this.attivoScontoPerc = info.attivoScontoPerc === '1' ? true : false;
        this.inizioPromo = info.inizioPromo;
        this.finePromo = info.finePromo;
        this.attivoVoucherCarrello = info.attivoVoucherCarrello === '1' ? true : false;
        this.scontoFromVoucher = parseFloat(info.scontoFromVoucher);
        this.attivoScontoFromVoucher = info.attivoScontoFromVoucher === '1' ? true : false;
    }
}